import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { Group } from "@/src/models/group";

/**
 * Config subdomains whose EHR integration is eCW (FHIR R4). Mirrors the eCW branches in
 * `ehr-factory.ts`. Kept in a leaf module (no I/O, no integration imports) so it can be used
 * from low-level layers like the repo without circular imports.
 */
export const ECW_EHR_CONFIG_SUBDOMAINS = new Set<string>([
  ConfigSubdomain.PINNACLE,
  ConfigSubdomain.ENT_PARTNERS,
  ConfigSubdomain.ENT_PARTNERS_SCI,
  ConfigSubdomain.ENT_PARTNERS_SUBOTO,
  ConfigSubdomain.ENT_PARTNERS_MENT,
  ConfigSubdomain.SIENT,
  ConfigSubdomain.HEARTPLACE,
  ConfigSubdomain.USHV_FORTWORTH,
  ConfigSubdomain.AUTONOMY,
  ConfigSubdomain.PA_EAST_REGION,
]);

export function isEcwGroup(group: Group): boolean {
  return ECW_EHR_CONFIG_SUBDOMAINS.has(getGroupConfigSubdomain(group));
}
